<template>
  <div v-loading="dataLoading" class="app-content-wrapper">
    <template v-if="hasAccountList && !dataLoading">
      <div class="search-wrapper">
        <search-component
          ref="search"
          :search-condition="searchCondition"
          :search-buttons="searchButtonList"
          :fuzzySearchPlaceholder="fuzzySearchPlaceholder"
          router-name="/collection/virtual-account/list"
        >
        </search-component>
      </div>
      <div class="table-wrapper">
        <custom-table
          :table-set="tableCondition"
          :service-function="getVAList"
          :additional-parameters="getAdditionalParameters()"
          ref="table"
          router-name="/collection/virtual-account/list"
        >
          <template #applyCurrency="{row}">
            <div class="currency-box">
              <img :src="getCurrencyImage(row.applyCurrency) ? require(`@/assets/images/currency/${row.applyCurrency}.png`) : ''" />
              <p class="currency-text">
                <span>{{row.applyCurrency}}</span>
                <span class="currency-desc">{{getCurrencyText(row.applyCurrency)}}</span>
              </p>
            </div>
          </template>
        </custom-table>
      </div>
    </template>
    <template v-if="!hasAccountList">
      <AccountEmpty @create="toAddPage()"></AccountEmpty>
    </template>
    <!-- <template v-if="!dataLoading">
      <virtual-account-add :visible="showAddDrawer" @close="showAddDrawer = false" @refresh="refreshTable"></virtual-account-add>
    </template> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import { getCurrentMenu } from '@/layout/base/components/inavbar/utils';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { getCurrencyImage } from '@/utils/tools/currency';
import { getVAList } from '@/views/collection/api/va.js';
// import VirtualAccountAdd from '@/views/collection/virtual-account/add/index.vue';
import AccountEmpty from '@/views/collection/virtual-account/list/empty.vue';

export default {
  components: {
    SearchComponent,
    CustomTable,
    AccountEmpty,
    // VirtualAccountAdd,
  },
  data() {
    return {
      dataLoading: false,
      hasAccountList: false,
      fuzzySearchPlaceholder: `${this.$t('message.collection.accountNumber')}`,
      searchCondition: [
        {
          key: 'applyCurrency',
          name: 'message.tableCommon.currency',
          type: 'select',
          defValue: '',
          options: [],
        },
      ],
      searchButtonList: [
        // {
        //   type: 'download',
        //   func: async (param) => {},
        // },
        {
          type: 'other',
          name: 'message.collection.createVirtualAccount',
          permissionCode: 'collection:virtualAccount:list:create',
          func: async () => {
            if (`${this.app.userLogin.merchantStatus}` === '4') { // 未启用时，弹出提示
              this.$bus.$emit('showAuditStatusAlert');
              return;
            }
            this.toAddPage();
          },
        },
      ],
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.tableCommon.currency', filterKey: 'applyCurrency' },
          key: 'applyCurrency',
          type: 'slot',
        },
        {
          titleBar: { type: 'text', title: 'message.collection.accountLabel' },
          key: 'accountLabel',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.collection.accountNumber' },
          key: 'accountNumber',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.collection.accountHolderName' },
          key: 'holderName',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.collection.bizType', filterKey: 'bizType' },
          key: 'bizType',
          type: 'text',
          textFunc: (row) => {
            return getEnantiomericValue(this.bizTypeList, row.bizType);
          },
        },
        {
          titleBar: { type: 'text', title: 'message.collection.bankLocation' },
          key: 'accountCountry',
          type: 'text',
          textFunc: (row) => {
            return getEnantiomericValue(this.countryList, row.accountCountry);
          },
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.status' },
          key: 'vaStatus',
          type: 'tag',
          textFunc: (row) => {
            if (!row.vaStatus) {
              return this.$t('message.status.pending');
            }
            return getEnantiomericValue(this.statusList, row.vaStatus);
          },
          tagTypeFunc: (row) => {
            if (row.vaStatus === '4') { // 已激活
              return 'success';
            } else if (row.vaStatus === '0') { // 初始化
              return 'danger';
            } else if (row.vaStatus === '2') { // 冻结
              return 'disabled';
            } else {
              return 'info';
            }
          },
        },
        {
          key: 'buttons',
          titleBar: {
            title: 'message.tableCommon.operation',
            type: 'operations',
          },
          type: 'operations',
          subTableDisplays: [
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.details',
              isDisplayFunc: (data) => !!data.vaStatus,
              permissionCode: 'collection:virtualAccount:list:detail',
              func: (data) => {
                this.$router.push({ path: '/collection/virtual-account/detail', query: { vaId: data.id } });
              },
            },
            {
              type: 'text_button',
              textFunc: () => 'message.common.profile',
              permissionCode: 'collection:virtualAccount:list:profile',
              func: (data) => {
                this.$router.push({ path: '/application/list', query: { appId: data.appId } });
              },
            },
          ],
        },
      ],
      showAddDrawer: false,
      countryList: [],
      bizTypeList: [],
      currencyList: [],
      statusList: [],
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  beforeCreate() {
    try {
      const menu = getCurrentMenu(this.$store.getters.permission.menus, {
        path: '/collection/virtual-account',
        meta: {
          resourceCode: 'collection:virtualAccount',
        },
      });
      const index = menu.childrenNode[0].menuUrl;
      if (index !== '/collection/virtual-account/list') {
        this.$router.push({ path: index });
      }
    } catch (err) {
      //
    }
  },
  created() {
    if (`${this.app.userLogin.businessType}` === '0') {
      this.searchButtonList[0].name = 'message.collection.createVirtualAccount1';
    } else {
      this.searchCondition.push({
        key: 'bizType',
        name: 'message.collection.bizType',
        type: 'select',
        defValue: '',
        options: [],
      });
    }
    this.initData();
  },
  methods: {
    getCurrencyImage,
    getVAList,
    async initData() {
      this.dataLoading = true;
      try {
        const dict = await GlobalData.getDictList(['COUNTRY', 'VA_BIZ_TYPE', 'VA_BIZ_CURRENCY', 'VA_STATUS']);
        this.countryList = initSelectedData(dict.COUNTRY);
        this.bizTypeList = initSelectedData(dict.VA_BIZ_TYPE);
        this.currencyList = initSelectedData(dict.VA_BIZ_CURRENCY);
        this.statusList = initSelectedData(dict.VA_STATUS);
        this.searchCondition[0].options = initSelectedData(dict.VA_BIZ_CURRENCY);
        if (this.searchCondition[1]) {
          this.searchCondition[1].options = initSelectedData(dict.VA_BIZ_TYPE);
        }
        const res = await getVAList({ size: 1 });
        if (res && res.content && res.content.length > 0) {
          this.hasAccountList = true;
        }
      } catch (err) {
        //
        console.log(err);
      }
      this.dataLoading = false;
    },
    refreshTable() {
      if (!this.hasAccountList) {
        this.initData();
      } else if (this.$refs.table) {
        this.$refs.table.refreshTable();
      }
    },
    getCurrencyText(currency) {
      return getEnantiomericValue(this.currencyList, currency);
    },
    toAddPage() {
      this.$router.push({ path: '/collection/virtual-account/add' });
    },
    getAdditionalParameters() {
      if (`${this.app.userLogin.businessType}` === '0') {
        return {
          bizType: 'B2B',
        };
      }
      return {};
    },
  },
};
</script>
<style lang="scss" scope>
@import '@/styles/variables.scss';

.currency-box {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: Avenir-Heavy, Avenir;
  font-weight: 800;
  color: $color-text-primary;
  line-height: 24px;

  & > img {
    width: 30px;
    height: 30px;
    margin-right: 13px;
  }

  .currency-text {
    display: flex;
    flex-direction: column;

    .currency-desc {
      font-size: 14px;
      font-family: Avenir-Medium, Avenir;
      font-weight: 500;
      line-height: 19px;
    }
  }
}
</style>
